import { __awaiter, __generator } from "tslib";
export var loggerMiddleware = function loggerMiddleware() {
  return function (next, context) {
    return function (args) {
      return __awaiter(void 0, void 0, void 0, function () {
        var logger, response, httpResponse;

        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              logger = context.logger;
              return [4
              /*yield*/
              , next(args)];

            case 1:
              response = _b.sent();

              if (!logger) {
                return [2
                /*return*/
                , response];
              }

              httpResponse = response.response;

              if (typeof logger.info === "function") {
                logger.info({
                  metadata: {
                    statusCode: httpResponse.statusCode,
                    requestId: (_a = httpResponse.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : httpResponse.headers["x-amzn-request-id"],
                    extendedRequestId: httpResponse.headers["x-amz-id-2"],
                    cfId: httpResponse.headers["x-amz-cf-id"]
                  }
                });
              }

              return [2
              /*return*/
              , response];
          }
        });
      });
    };
  };
};
export var loggerMiddlewareOptions = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize"
}; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var getLoggerPlugin = function getLoggerPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
    }
  };
};